/**
 * Video Configuration
 * 
 * To use Daily.co video:
 * 1. Create account at https://www.daily.co/
 * 2. Get your API key from dashboard
 * 3. Add to .env file: REACT_APP_DAILY_API_KEY=your_api_key
 * 4. Add to .env file: REACT_APP_DAILY_DOMAIN=your_domain.daily.co (optional)
 */

const videoConfig = {
  // Daily.co configuration
  daily: {
    apiKey: process.env.REACT_APP_DAILY_API_KEY || '',
    domain: process.env.REACT_APP_DAILY_DOMAIN || '',
    // Default room settings (only valid Daily.co properties)
    defaultRoomSettings: {
      max_participants: 50,
      enable_screenshare: true,
      enable_chat: true,
      enable_recording: false, // Enable when needed
      enable_knocking: false, // Waiting room
      enable_prejoin_ui: true,
      start_video_off: false,
      start_audio_off: false, // Students muted by default
      enable_network_ui: true // Show network quality
    },
    // Security settings
    security: {
      maxSessionDuration: 2 * 60 * 60 * 1000, // 2 hours in milliseconds
      maxRoomsPerUserPerDay: 10, // Rate limiting
      autoDisconnectAfter: 2 * 60 * 60 * 1000, // Auto-disconnect after 2 hours
      studentCanCreateRoom: false, // Students cannot create rooms
      allowedRoles: ['admin', 'coach'] // Only these roles can create rooms
    }
  },
  
  // Fallback to external URL if Daily.co not configured
  useExternalUrl: !process.env.REACT_APP_DAILY_API_KEY,
  
  // Video quality settings
  quality: {
    low: { width: 320, height: 240, frameRate: 15 },
    medium: { width: 640, height: 480, frameRate: 24 },
    high: { width: 1280, height: 720, frameRate: 30 }
  }
};

export default videoConfig;

